import React from "react";
import { Link, useLocation } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { LayoutDashboard, Anchor, Settings, Package, Clipboard, LifeBuoy } from "lucide-react";

const MobileNavbar = () => {
  const location = useLocation();
  const { t } = useTranslation("common");
  
  const menuItems = [
    { to: "/dashboard", icon: LayoutDashboard, label: t("nav.dashboard") },
    { to: "/mes-bateaux", icon: Anchor, label: t("nav.boatsShort") },
    { to: "/maintenance", icon: Settings, label: t("nav.maintenance") },
    { to: "/inventory", icon: Package, label: t("nav.inventory") },
    { to: "/checklists", icon: Clipboard, label: t("nav.checklists") },
    { to: "/assistant", icon: LifeBuoy, label: t("nav.assistant") }
  ];
  
  return (
    <nav className="mobile-navbar fixed bottom-0 left-0 right-0 bg-white border-t border-gray-200 z-50 shadow-lg lg:hidden">
      <div className="flex items-center py-2 w-full">
        {menuItems.map((item) => {
          const IconComponent = item.icon;
          const isActive = location.pathname === item.to;
          
          return (
            <Link 
              key={item.to}
              to={item.to} 
              className={`flex flex-1 min-w-0 flex-col items-center justify-center py-2 px-1 ${
                isActive ? "text-nautic-gold" : "text-gray-500"
              }`}
            >
              <IconComponent className="h-5 w-5" />
              <span className="text-xs mt-1 text-center leading-tight w-full break-words">{item.label}</span>
            </Link>
          );
        })}
      </div>
    </nav>
  );
};

export default MobileNavbar;
